import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Badge,
  Card,
  Dropdown,
  Button,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown
} from "@fortawesome/free-solid-svg-icons";
import "../../scss/fcsvendor/layout/_vendor.scss";
import { getTimeOff, updateTimeOffStatus } from "../../app/api";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import swal from "sweetalert";
import Loader from "../../components/Loader";
import moment from "moment";

export default () => {
  const { id } = useParams();
  const history = useHistory();

  const [statuses, setStatuses] = useState({});
  const [fromdate, setFromdate] = useState("");
  const [todate, setTodate] = useState("");
  const [status, setStatus] = useState("");
  const [notes, setNotes] = useState("");
  const [details, setSDetails] = useState("");
  const [vendor, setVendor] = useState();
  const [email, setEmail] = useState();
  const [updatedby, setUpdatedBy] = useState("");
  const [vendorId, setVendorID] = useState("");
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState("");
  const handleStatusChange = (newStatus) => {
    handleUpdateStatus(newStatus); // Call the update function
  };
  const handleUpdateStatus = async (newStatus) => {
    setLoading(true);

    try {
      const token = localStorage.getItem("token");

      const TimeOffData = {
        status: newStatus,
      };
      let response;

      response = await axios.put(updateTimeOffStatus(id), TimeOffData, {
        headers: {
          "Content-Type": "application/json", // Set Content-Type to application/json
          "secret-key": process.env.REACT_APP_SECRET_KEY, // Include the secret-key
          "auth-token": `Bearer ${token}`,
        },
      });
      // Update the local status state
      setStatuses((prevStatuses) => ({
        ...prevStatuses,
        [vendorId]: newStatus,
      }));
      swal({
        text: response.data.message,
        icon: "success",
      });

      // console.log(response.data);
    } catch (error) {
      swal({
        text: error.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
    fetchSingleTimeoff();
  };
  const fetchSingleTimeoff = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getTimeOff(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      setEmail(response.data?.data?.email);
      setStatus(response.data?.data?.status);
      setVendor(response.data?.data?.vendor_name);
      setUpdatedBy(response.data?.data?.updated_by_name);
      setFromdate(response.data?.data?.time_off_from);
      setTodate(response.data?.data?.time_off_to);

      setNotes(response.data?.data?.notes);
      setSDetails(response.data?.data?.details);
      setVendorID(response.data?.data?.vendor_id);
      setDate(response.data?.data?.created_at);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSingleTimeoff();
  }, [id]);
  const handleBackClick = () => {
    history.push(Routes.Timeoff.path);
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block mb-md-0">
              {/* <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            
            <Breadcrumb.Item active>Time Off Detail</Breadcrumb.Item>
          </Breadcrumb> */}
              <h4 className="mb-0">Time Off Details</h4>
            </div>
            <Button
              variant="primary"
              onClick={handleBackClick}
              className=" me-2"
            >
              <span>Back</span>
            </Button>
          </div>

        
          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                
                  <Col xs={12} sm={12} xl={12} lg={12}>
                    <Row>
                                        <Col xs={12} sm={6} xl={4} lg={4}>
                                          <p className="vendor-title">Vendor Name:</p>{" "}
                                          <p className="vendor-detail">{vendor}</p>{" "}
                                        </Col>
                  
                                        <Col xs={12} sm={6} xl={4} lg={4}>
                                          <p className="vendor-title">Email:</p>
                                          <p className="vendor-detail">{email}</p>{" "}
                                        </Col>
                  
                                        <Col xs={12} sm={6} xl={4} lg={4}>
                                          <p className="vendor-title">Updated by Name:</p>
                                          <p className="vendor-detail">{updatedby}</p>{" "}
                                        </Col>
                                      </Row>
                 
                                      <Row>
                                        
                  
                                        <Col xs={12} sm={6} xl={4} lg={4}>
                                          <p className="vendor-title">Time Off From:</p>
                                          <p className="vendor-detail">{moment(fromdate).format("MM/DD/YYYY HH:mm")}</p>{" "}
                                        </Col>
                  
                                        <Col xs={12} sm={6} xl={4} lg={4}>
                                          <p className="vendor-title">Time Off To:</p>
                                          <p className="vendor-detail">{moment(todate).format("MM/DD/YYYY HH:mm")}</p>{" "}
                                        </Col>
                                        <Col xs={12} sm={6} xl={4} lg={4}>
                                          <p className="vendor-title">Status:</p>{" "}
                                          <p className="vendor-detail"> <Dropdown
                              onSelect={(eventKey) =>
                                handleStatusChange(eventKey)
                              }
                            >
                              <Dropdown.Toggle
                               id="dropdown-basic"
                                 variant="primary"
                                className="Dropdown_selector"
                              >
                                
                                  {" "}
                                  {status } <FontAwesomeIcon icon={faAngleDown} />
                               
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item eventKey="pending">
                                  Pending
                                </Dropdown.Item>
                                <Dropdown.Item eventKey="approved">
                                  Approve
                                </Dropdown.Item>
                                <Dropdown.Item eventKey="rejected">
                                  Rejected
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown></p>{" "}
                                        </Col>
                                      </Row>
                 
                                      <Row>
                                        <Col xs={12} sm={6} xl={4} lg={4}>
                                          <p className="vendor-title">Detail:</p>{" "}
                                          <p className="vendor-detail">{details}</p>{" "}
                                        </Col>
                  
                                        <Col xs={12} sm={6} xl={4} lg={4}>
                                          <p className="vendor-title">Notes:</p>
                                          <p className="vendor-detail">{notes}</p>{" "}
                                        </Col>
                  
                                        <Col xs={12} sm={6} xl={4} lg={4}>
                                          <p className="vendor-title">Created Date:</p>
                                          <p className="vendor-detail">{moment(date).format("MM/DD/YYYY HH:mm")}</p>{" "}
                                        </Col>
                                      </Row>
                   


                  </Col>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};
